// 軽量アウトラインアイコン（依存なし）。stroke ベースで currentColor を継承する。

export type IconName =
  | "home" | "chart" | "chat" | "document" | "briefcase" | "users" | "building"
  | "store" | "cash" | "check" | "calendar" | "adjust" | "clipboard" | "refund"
  | "shield" | "usercog" | "cog" | "upload" | "menu" | "close" | "bell" | "grid" | "org" | "search";

const PATHS: Record<IconName, string> = {
  home: "M3 10.5 12 3l9 7.5M5 9.5V21h5v-6h4v6h5V9.5",
  chart: "M4 19h16M7 16v-5M12 16V7M17 16v-8",
  chat: "M8 10h8M8 14h5M21 12a8 8 0 0 1-11.5 7.2L4 20l1-4.2A8 8 0 1 1 21 12Z",
  document: "M8 3h6l4 4v14H6V3h2Zm6 0v4h4M9 13h6M9 17h6",
  briefcase: "M4 8h16v12H4V8Zm5 0V6a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2M4 13h16",
  users: "M9 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm-6 8a6 6 0 0 1 12 0M17 11a3 3 0 1 0 0-6M21 19a6 6 0 0 0-4-5.6",
  building: "M5 21V5a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v16M9 7h2M9 11h2M9 15h2M15 21V11h4v10M5 21h16",
  store: "M4 9 5 4h14l1 5M4 9v11h16V9M4 9h16M9 20v-5h6v5",
  cash: "M3 7h18v10H3V7Zm9 2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5ZM6 9.5h.01M18 14.5h.01",
  check: "M4 12.5 9 17.5 20 6.5",
  calendar: "M4 6h16v15H4V6Zm0 5h16M8 3v4M16 3v4",
  adjust: "M4 7h10M18 7h2M4 17h2M10 17h10M14 5v4M8 15v4",
  clipboard: "M9 4h6v3H9V4Zm-2 1H5v16h14V5h-2M9 12h6M9 16h6",
  refund: "M4 9a8 8 0 0 1 14-4l2 2M20 5v4h-4M20 15a8 8 0 0 1-14 4l-2-2M4 19v-4h4",
  shield: "M12 3 5 6v6c0 4 3 7 7 9 4-2 7-5 7-9V6l-7-3Zm-2.5 8.5L11 13l4-4",
  usercog: "M9 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm-6 8a6 6 0 0 1 9-5.2M18 13.5v1M18 19v1M21 16.5l-.9.5M15.9 18l-.9.5M21 17.5l-.9-.5M15.9 16l-.9-.5M18 15a1.7 1.7 0 1 0 0 3.4A1.7 1.7 0 0 0 18 15Z",
  cog: "M12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm0-6 1.5 2.6 3-.4.6 3 2.6 1.5-1.4 2.7 1.4 2.6-2.6 1.6-.6 3-3-.4L12 21l-1.5-2.6-3 .4-.6-3L4.3 14l1.4-2.6L4.3 8.8l2.6-1.5.6-3 3 .4L12 3Z",
  upload: "M12 16V4m0 0L8 8m4-4 4 4M5 20h14",
  menu: "M4 6h16M4 12h16M4 18h16",
  close: "M6 6l12 12M18 6 6 18",
  bell: "M15 17h5l-1.4-1.4A2 2 0 0 1 18 14.2V11a6 6 0 1 0-12 0v3.2c0 .5-.2 1-.6 1.4L4 17h5m6 0a3 3 0 1 1-6 0",
  grid: "M4 4h7v7H4V4Zm9 0h7v7h-7V4ZM4 13h7v7H4v-7Zm9 0h7v7h-7v-7Z",
  search: "M21 21l-4.3-4.3M11 18a7 7 0 1 1 0-14 7 7 0 0 1 0 14Z",
  org: "M3 21V8l6-3v16M9 21V4l6 2.5V21M15 21V10l6 2.5V21M2 21h20M12 9h.01M12 13h.01M6 11h.01M6 15h.01",
};

export function Icon({ name, className = "h-5 w-5" }: { name: IconName; className?: string }) {
  return (
    <svg className={className} fill="none" stroke="currentColor" strokeWidth={1.8}
      strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" aria-hidden="true">
      <path d={PATHS[name]} />
    </svg>
  );
}
